import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
    const { theme = "system" } = useTheme();

    return (
        <Sonner
            theme={theme as ToasterProps["theme"]}
            className="toaster group"
            closeButton
            duration={4000}
            gap={8}
            toastOptions={{
                classNames: {
                    toast: "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-800 group-[.toaster]:border group-[.toaster]:border-gray-200/80 group-[.toaster]:shadow-[0_4px_24px_-4px_rgba(0,0,0,0.08)] group-[.toaster]:rounded-lg group-[.toaster]:px-4 group-[.toaster]:py-3 group-[.toaster]:text-[13px] group-[.toaster]:font-medium group-[.toaster]:backdrop-blur-sm",
                    description:
                        "group-[.toast]:text-gray-500 group-[.toast]:text-[12px] group-[.toast]:font-normal",
                    actionButton:
                        "group-[.toast]:bg-gray-900 group-[.toast]:text-white group-[.toast]:rounded-md group-[.toast]:text-[12px] group-[.toast]:font-medium group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:hover:bg-gray-800 group-[.toast]:transition-colors group-[.toast]:duration-150",
                    cancelButton:
                        "group-[.toast]:bg-transparent group-[.toast]:text-gray-500 group-[.toast]:rounded-md group-[.toast]:text-[12px] group-[.toast]:hover:text-gray-700 group-[.toast]:hover:bg-gray-100 group-[.toast]:transition-colors group-[.toast]:duration-150",
                    closeButton:
                        "group-[.toast]:!bg-white group-[.toast]:!border-gray-200 group-[.toast]:!text-gray-400 group-[.toast]:hover:!text-gray-600 group-[.toast]:!shadow-sm group-[.toast]:!transition-colors group-[.toast]:!duration-150",
                    success:
                        "group-[.toaster]:!border-l-[3px] group-[.toaster]:!border-l-emerald-500 group-[.toaster]:!border-t-gray-200/80 group-[.toaster]:!border-r-gray-200/80 group-[.toaster]:!border-b-gray-200/80",
                    error:
                        "group-[.toaster]:!border-l-[3px] group-[.toaster]:!border-l-red-500 group-[.toaster]:!border-t-gray-200/80 group-[.toaster]:!border-r-gray-200/80 group-[.toaster]:!border-b-gray-200/80",
                    info:
                        "group-[.toaster]:!border-l-[3px] group-[.toaster]:!border-l-blue-500 group-[.toaster]:!border-t-gray-200/80 group-[.toaster]:!border-r-gray-200/80 group-[.toaster]:!border-b-gray-200/80",
                    warning:
                        "group-[.toaster]:!border-l-[3px] group-[.toaster]:!border-l-amber-500 group-[.toaster]:!border-t-gray-200/80 group-[.toaster]:!border-r-gray-200/80 group-[.toaster]:!border-b-gray-200/80",
                },
            }}
            {...props}
        />
    );
};

export { Toaster };
